export default "__VITE_ASSET__D_0JPt8S__"